import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query';

import type { AnnouncementItem, MyNotification } from '@/api/types.js';
import type { Ref } from 'vue';

import { apiClient } from '@/api/client.js';

export function useAnnouncementsQuery(eventId: Ref<string>) {
  return useQuery({
    queryKey: ['event', eventId, 'announcements'],
    queryFn: () =>
      apiClient.get<AnnouncementItem[]>(`/api/v1/events/${eventId.value}/announcements`),
  });
}

export function useCreateAnnouncementMutation(eventId: Ref<string>) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Record<string, unknown>) =>
      apiClient.post<AnnouncementItem>(`/api/v1/events/${eventId.value}/announcements`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['event', eventId, 'announcements'] }),
  });
}

export function usePublishAnnouncementMutation(eventId: Ref<string>) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      apiClient.post<{ recipients: number; emailQueued: number }>(
        `/api/v1/events/${eventId.value}/announcements/${id}/publish`,
      ),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['event', eventId, 'announcements'] }),
  });
}

/** Лента участника — по всем его мероприятиям сразу. */
export function useMyNotificationsQuery() {
  return useQuery({
    queryKey: ['my-notifications'],
    queryFn: () => apiClient.get<MyNotification[]>('/api/v1/me/notifications'),
  });
}

export function useMarkReadMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (ids: string[]) =>
      apiClient.post<{ updated: number }>('/api/v1/me/notifications/read', { ids }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['my-notifications'] }),
  });
}
